<template>
  <div>
    <a href="#" :data-testid="'pro-link-'+id" v-bind="$attrs" v-on="$listeners" @click="onClick()">
      <img v-if="! payingUser"
           src="@img/pro-ribbon.png" class="img-pro-ribbon" :data-testid="'img-pro-ribbon-' + id">
      <span data-toggle="tooltip" data-placement="top" :title="title" class="icon">
        <img :src="icon" :alt="title">
      </span>
      <p class="owner-action-label"><slot></slot></p>
    </a>
  </div>
</template>

<script>
export default  {
  props: ["title", "id", "icon"],
  computed: {
    // User can be not "paying" AND not "free", if they have a trial.
    payingUser: function() {
      return (this.$store.state.currentOrganization.attributes.is_paying == true);
    },
    freeUser: function() {
      return (this.$store.state.currentOrganization.attributes.free == true);
    }
  },
  methods: {
    onClick: function(event) {
      this.$emit(this.freeUser ? "free-click" : "pro-click", event);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/packs/application.scss';

span.icon {
  display: inline-block;
  height: 100%;
  vertical-align: top;
}

img {
  height: 1rem;
  vertical-align: top;
}
</style>